import React, { Component } from 'react';
import './iamExUsTitleBar.css';
import {servicesArray} from '../../utils/allServicesArray.json';

class IamExUsTitleBar extends Component {

  state = {
    inputUser: '',
    inputService: ''
  };

  componentDidMount() {

  };

  render() {

    const userArray = this.props.users.map(user => {
      return `${user.UserName} - ${user.Account} (${user.AccountId}) - ${user.UserId}`;
    });

    return (
      <div className="IamExUsTitleBarPage">
        <h1>
                    IAM User Explorer
        </h1>
        <input className="inputService" list="services" name="service" value={this.state.inputService} onChange={this.handleInput} onKeyDown={this.handleEnterPress} placeholder="Search..."/>
        <datalist id="services">
          {servicesArray.map(service => {
            return <option key={`option-${service}`} value={service}></option>;
          })}
        </datalist>
        <input className="inputUser" list="users" name="user" value={this.state.inputUser} onChange={this.handleInput} onKeyDown={this.handleEnterPress} placeholder="Search..."/>
        <datalist id="users">
          {userArray.map(user => {
            return <option key={`option-${user}`} value={user}></option>;
          })}
        </datalist>
        <button onClick={this.handleSubmit}>Submit</button>
        <div>
          <button onClick={this.props.refreshIamInformation}>Refresh IAM Information</button>
          <p>{`IAM information last updated ${this.props.updateDate}`}</p>
        </div>
      </div>
    );
  };

    handleInput = e => {
      this.setState({[e.target.className] : e.target.value});
    }

    handleEnterPress = e => {
      if (e.key === 'Enter') this.handleSubmit();
    };

    handleSubmit = () => {
      if (this.state.inputUser.match(/.* - .* - (.*)/)) {
        const userId = this.state.inputUser.match(/.* - .* - (.*)/)[1];
        this.props.selectUser(userId);
        this.props.filterActions(this.state.inputService);
      }
    }

};

export default IamExUsTitleBar;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExUsers/iamExUsTitleBar/iamExUsTitleBar.js